export var ReplyType;
(function (ReplyType) {
    ReplyType[ReplyType["USER"] = 100] = "USER";
    ReplyType[ReplyType["CC_USER"] = 101] = "CC_USER";
    ReplyType[ReplyType["EXTERNAL_USER"] = 102] = "EXTERNAL_USER";
    ReplyType[ReplyType["AGENT"] = 110] = "AGENT";
    ReplyType[ReplyType["INTERNAL"] = 120] = "INTERNAL";
})(ReplyType || (ReplyType = {}));
//# sourceMappingURL=reply-type.enum.js.map